export function formateDate(time) {
  if (!time) return "";
  let date = new Date(time);

  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  var hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
  var min =
    date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
  var sec =
    date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();

  return year + "-" + month + "-" + day + " " + hour + ":" + min + ":" + sec;
}

export function formateHHMMDate(time) {
  if (!time) return "";
  let date = new Date(time);
  var hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
  var min =
    date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
  return hour + ":" + min;
}

export function formateHHMMSSDate(time) {
  if (!time) return "";
  let date = new Date(time);
  let hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
  let min = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
  let sec = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
  return hour + ":" + min + ":" + sec;
}


export function formateZeroFillDate(time) {
  if (!time) return "";
  let date = new Date(time);
  const weekDay = ["日", "一", "二", "三", "四", "五", "六"];
  var year = date.getFullYear();
  var month =
    date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1;
  var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
  var week = weekDay[date.getDay()];
  var hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
  var min =
    date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
  var sec =
    date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();

  return (
    year +
    "-" +
    month +
    "-" +
    day +
    "-" +
    hour +
    ":" +
    min +
    ":" +
    sec +
    "-" +
    week
  );
}

export function formateShortDate(time) {
  if (!time) return "";
  let date = new Date(time);

  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();

  return year + "-" + month + "-" + day;
}

export function formateDate_YMD(time) {
  if (!time) return "";
  let date = new Date(time);

  var year = date.getFullYear();
  var month =
    date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1;
  var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();

  return year + month + day;
}

export function getSundayOfWeek(time) {
  var now = time;
  var nowTime = now.getTime();
  var day = now.getDay();
  var sunday = new Date(nowTime - (day - 1) * 24 * 60 * 60 * 1000);
  return sunday;
}

export function getFriday() {
  let today = new Date();
  let dayOfWeek = today.getDay();
  let friday = new Date(today);
  friday.setDate(today.getDate() + (5 - dayOfWeek));

  function formatDate(date) {
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    return `${year}${(month < 10 ? "0" : "") + month}${
      (day < 10 ? "0" : "") + day
    }`;
  }

  return formatDate(friday);
}

export function getSaturday() {
  let today = new Date();
  let dayOfWeek = today.getDay();
  let saturday = new Date(today);
  saturday.setDate(today.getDate() + (6 - dayOfWeek));

  function formatDate(date) {
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    return `${year}${(month < 10 ? "0" : "") + month}${
      (day < 10 ? "0" : "") + day
    }`;
  }

  return formatDate(saturday);
}
export function getTodayDate() {
  let date = new Date();
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();

  // 添加前导零
  if (month < 10) month = '0' + month;
  if (day < 10) day = '0' + day;

  return `${year}${month}${day}`;
}

export function getYesterdayDate() {
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);

  const yyyy = yesterday.getFullYear();
  const MM = String(yesterday.getMonth() + 1).padStart(2, "0");
  const dd = String(yesterday.getDate()).padStart(2, "0");

  return `${yyyy}${MM}${dd}`;
}

export function getNextMonday(date = new Date()) {
  const day = date.getDay();
  const nextMonday = new Date(date);
  const daysToAdd = (1 + 7 - day) % 7 || 7; // 如果今天是周一，则加7天
  nextMonday.setDate(date.getDate() + daysToAdd);
  return formatDateToYYYYMMDD(nextMonday);
}

export function getNextThursday(date = new Date()) {
  const targetDay = 4; 
  const currentDay = date.getDay();

  const daysUntilNextThursday = (targetDay + 7 - currentDay) % 7 || 7;
  const nextThursday = new Date(date);
  nextThursday.setDate(date.getDate() + daysUntilNextThursday);
  return formatDateToYYYYMMDD(nextThursday); 
}

function formatDateToYYYYMMDD(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份补零
  const day = String(date.getDate()).padStart(2, "0"); // 日期补零
  return `${year}${month}${day}`;
}

export function formateDateDb(time) {
  if (!time) return "";
  let date = new Date(time * 1000);
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  var hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
  var min =
    date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
  //var sec = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()

  return year + "-" + month + "-" + day + " " + hour + ":" + min;
}

export function formateDateDbT(time) {
  if (!time) return "";
  let date = new Date(time);
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  var hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
  var min =
    date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
  //var sec = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()

  return year + "-" + month + "-" + day + " " + hour + ":" + min;
}

export function formateDateDbT_ALL(time) {
  if (!time) return "";
  let date = new Date(time);
  var year = date.getFullYear();
  var month =
    date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1;
  var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
  var hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
  var min =
    date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
  var sec =
    date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();

  return year + "/" + month + "/" + day + " " + hour + ":" + min + ":" + sec;
}

// export function formateDateDbT_YMD(time) {
//   if (!time) return "";
//   let date = new Date(time);
//   var year = date.getFullYear();
//   var month =
//     date.getMonth() + 1 < 10
//       ? "0" + (date.getMonth() + 1)
//       : date.getMonth() + 1;
//   var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();

//   return year + month + day;
// }

export function formateDateDbT_YMD(time) {
  if (!time) return "";
  let date = new Date(time);
  let year = date.getFullYear().toString();
  let month = (date.getMonth() + 1).toString().padStart(2, '0');
  let day = date.getDate().toString().padStart(2, '0');

  return year + month + day;
}

export function formateDatetimestamp(time) {
  if (!time) return "";
  let date = new Date(time);
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  var hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
  var min =
    date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
  //var sec = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()

  return year + "-" + month + "-" + day + " " + hour + ":" + min;
}

export function convertMinutesToHoursAndMinutes(minutes) {
  let hours = Math.floor(minutes / 60);
  let remainingMinutes = minutes % 60;

  return `${hours}小時 ${remainingMinutes}分鐘`;
}

/**
 * 將總時數轉換為工作日與時（以 8 小時為一日），格式為 00日00時
 * @param {number} totalHours - 總小時數
 * @returns {string} 格式化後的字串 (e.g., "02日04時")
 */
export function convertToWorkDaysPadded(totalHours) {
  if (typeof totalHours !== 'number' || totalHours < 0) {
    return "00日00時";
  }

  const hoursPerDay = 8;
  const days = Math.floor(totalHours / hoursPerDay);
  const hours = Math.floor(totalHours % hoursPerDay); // 使用 Math.floor 確保小時也是整數

  // 將數字轉為字串並補零至兩位數
  const paddedDays = days.toString().padStart(2, '0');
  const paddedHours = hours.toString().padStart(2, '0');

  return `${paddedDays}日${paddedHours}時`;
}

export function formateDatetimeStart(time) {
  if (!time) return "";
  let date = new Date(time);
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  //var sec = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()

  return year + "-" + month + "-" + day + " 00:00";
}

export function formateDatetimeEnd(time) {
  if (!time) return "";
  let date = new Date(time);
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  //var sec = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()

  return year + "-" + month + "-" + day + " 23:59";
}

export function getDateYYYYMMDD(Date) {
  let TimeNow = Date ? Date : new Date();

  var yyyy = TimeNow.toLocaleDateString().slice(0, 4);
  var MM = (TimeNow.getMonth() + 1 < 10 ? "0" : "") + (TimeNow.getMonth() + 1);
  var dd = (TimeNow.getDate() < 10 ? "0" : "") + TimeNow.getDate();
  //var h = (TimeNow.getHours() < 10 ? '0' : '') + TimeNow.getHours();
  //var m = (TimeNow.getMinutes() < 10 ? '0' : '') + TimeNow.getMinutes();
  //var s = (TimeNow.getSeconds() < 10 ? '0' : '') + TimeNow.getSeconds();

  return yyyy + MM + dd;
}

export function getDateYYYYMM(Date) {
  let TimeNow = Date ? Date : new Date();

  var yyyy = TimeNow.toLocaleDateString().slice(0, 4);
  var MM = (TimeNow.getMonth() + 1 < 10 ? "0" : "") + (TimeNow.getMonth() + 1);
  //var dd = (TimeNow.getDate() < 10 ? '0' : '') + TimeNow.getDate();
  //var h = (TimeNow.getHours() < 10 ? '0' : '') + TimeNow.getHours();
  //var m = (TimeNow.getMinutes() < 10 ? '0' : '') + TimeNow.getMinutes();
  //var s = (TimeNow.getSeconds() < 10 ? '0' : '') + TimeNow.getSeconds();

  return yyyy + MM;
}

export function getPlanAcademicYear(Date) {
  let TimeNow = Date ? Date : new Date();
  var Month = TimeNow.getMonth() + 1;
  var academicYear = TimeNow.getFullYear() - 1911;
  if (Month > 8) {
    academicYear = academicYear + 1;
  }
  return academicYear.toString();
}

export function getSSPAcademicYear(Date) {
  let TimeNow = Date ? Date : new Date();
  var Month = TimeNow.getMonth() + 1;
  var academicYear = TimeNow.getFullYear() - 1911;
  if (Month > 10) {
    academicYear = academicYear + 1;
  }
  return academicYear.toString();
}

export function getNowAcademicYear(Date) {
  let TimeNow = Date ? Date : new Date();
  var Month = TimeNow.getMonth() + 1;
  var academicYear = TimeNow.getFullYear() - 1911;
  if (Month > 7) {
  } else {
    academicYear = academicYear - 1;
  }
  return academicYear.toString();
}

export function getGraduateAcademicYear(Date) {
  let TimeNow = Date ? Date : new Date();
  var Month = TimeNow.getMonth() + 1;
  var academicYear = TimeNow.getFullYear() - 1911;
  if (Month > 7) {
    academicYear = academicYear - 1;
  } else {
    academicYear = academicYear - 2;
  }
  return academicYear.toString();
}

export function getNowAcademicSemester(Date) {
  let TimeNow = Date ? Date : new Date();
  var Month = TimeNow.getMonth() + 1;
  var academicSemester = "1";
  if (Month > 7 || Month < 2) {
    academicSemester = "1";
  } else {
    academicSemester = "2";
  }
  return academicSemester;
}

export function getScholarshipAcademicSemester(Date) {
  let TimeNow = Date ? Date : new Date();
  var Month = TimeNow.getMonth() + 1;
  var academicSemester = "1";
  if (Month > 7) {
    academicSemester = "1";
  } else {
    academicSemester = "2";
  }
  return academicSemester;
}

export function getNowMonth(Date) {
  let TimeNow = Date ? Date : new Date();
  var Month = TimeNow.getMonth() + 1;
  return Month;
}

export function getCurrentMonthFirstDay() {
  let date = new Date();
  date.setDate(1); // 設定日期為當月第一天

  let year = date.getFullYear();
  let month = date.getMonth() + 1; // 月份從 0 開始，所以要加 1

  // 將月份和日期轉為兩位數字
  if (month < 10) {
    month = "0" + month;
  }

  return `${year}${month}01`;
}

export function getCurrentMonthLastDay() {
  let date = new Date();
  let year = date.getFullYear();
  let month = date.getMonth() + 1; // 月份從 0 開始，所以要加 1

  // 計算當月最後一天
  let lastDay = new Date(year, month, 0).getDate();

  // 將月份和日期轉為兩位數字
  if (month < 10) {
    month = "0" + month;
  }

  return `${year}${month}${lastDay.toString().padStart(2, "0")}`;
}

export function getTomorrowDateYYYYMMDD(Date) {
  let TimeNow = Date ? Date : new Date(); // 確保 TimeNow 是一個 Date 物件

  // 取得明天的日期
  TimeNow.setDate(TimeNow.getDate() + 1);

  var yyyy = TimeNow.getFullYear(); // 使用 getFullYear() 取得完整的年份
  var MM = ((TimeNow.getMonth() + 1) < 10 ? "0" : "") + (TimeNow.getMonth() + 1);
  var dd = (TimeNow.getDate() < 10 ? "0" : "") + TimeNow.getDate();

  return yyyy + MM + dd;
}

//防抖（Debounce）
export function debounce(func, wait) {
  let timeout;
  return function () {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.apply(this, arguments);
    }, wait);
  };
}
//節流（Throttle）
export function throttle(func, limit) {
  let inThrottle;
  return function () {
    if (!inThrottle) {
      func.apply(this, arguments);
      inThrottle = true;
      setTimeout(() => (inThrottle = false), limit);
    }
  };
}

export function  timestampToTime(timestamp)   {
  const date = new Date(timestamp * 1000); // 將秒轉換為毫秒
  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  const dayOfWeek = days[date.getUTCDay()];
  const month = months[date.getUTCMonth()];
  const day = date.getUTCDate().toString().padStart(2, '0');
  const year = date.getUTCFullYear();
  const hour = (date.getUTCHours() + 8).toString().padStart(2, '0'); // 手動加上台北時區的偏移
  const minute = date.getUTCMinutes().toString().padStart(2, '0');
  const second = date.getUTCSeconds().toString().padStart(2, '0');

  const timezoneName = 'GMT+0800 (台北標準時間)';
  return `${dayOfWeek} ${month} ${day} ${year} ${hour}:${minute}:${second} ${timezoneName}`;
}